import React, {useReducer} from "react";
import GoalContext from "./goal-context";
var viewportWidth = window.innerWidth || document.documentElement.clientWidth;

const defaultGoalState = () => {
  var pathName = window.location.pathname;
  var pathSplitter = pathName.split('/').filter(Boolean);
  if(pathName !== '/' && pathSplitter.length > 1 && !isNaN(pathSplitter[1]) && parseInt(pathSplitter[1]) > 0 && parseInt(pathSplitter[1]) <= window.goalData.length){
    if(viewportWidth > 992) {
      setTimeout(() => {
        const goalAnchor = document.querySelector(`#goal-` + parseInt(pathSplitter[1]));
        goalAnchor.scrollIntoView({
          behavior: 'auto'
        });
      }, 250)
    }
    return { activeGoal: parseInt(pathSplitter[1]) }
  }else{
    window.history.replaceState(null, '', '/');
    return { activeGoal: null }
  }
};

const defaultLocationState = () => {
  var pathName = window.location.pathname;
  var pathSplitter = pathName.split('/').filter(Boolean);

  if(pathName !== '/' && pathSplitter.length > 3 && !isNaN(pathSplitter[1]) && parseInt(pathSplitter[1]) > 0 && parseInt(pathSplitter[1]) <= window.goalData.length){
    let goalID = pathSplitter[1];
    let slug = pathSplitter[3];

    for(let i = 0; i < window.goalData[goalID - 1].locations.length;i++){
      if(window.goalData[goalID - 1].locations[i].slug === slug){
        if(viewportWidth > 992) {
          setTimeout(() => {
            const goalAnchor = document.querySelector(`#goal-` + parseInt(pathSplitter[1]));
            if(goalAnchor){
              goalAnchor.scrollIntoView({
                behavior: 'auto'
              });
            }
          }, 250)
          setTimeout(() => {
            const locationAnchor = document.querySelector(`#location-` + parseInt(i));
            if(locationAnchor){
              locationAnchor.scrollIntoView({
                behavior: 'auto'
              });
              locationAnchor.click();
            }
          }, 250)
        }
        return { activeLocation: i }
      }
    }
  }else if(pathSplitter.length === 2){
    return { activeLocation: null }
  }else{
    window.history.replaceState(null, '', '/');
    return { activeLocation: null }
  }
};

const defaultMapInstanceState = {
  instance: null
};

const defaultActiveMarkerState = {
  activeMarker: null
};

const defaultSwiperState = {
  instance: null
};

const goalReducer = (state, action) => {
    if (action.type === "SET") {
        const activeID = action.id
        return{
            activeGoal:  activeID
        }
    }
    return defaultGoalState;
}

const locationReducer = (state, action) => {
  if (action.type === "SET") {
      const activeID = action.id;
      return{
        activeLocation:  activeID,
      }
  }
  return defaultLocationState;
}

const mapInstanceReducer = (state, action) => {
  if(action.type === 'SET') {
    const instance = action.instance;
    return{
      instance
    }
  }
  return defaultMapInstanceState;
}

const markerReducer = (state, action) => {
  if(action.type === 'SET') {
    const marker = action.id;
    return{
      activeMarker: marker
    }
  }
  return defaultActiveMarkerState;
}

const swiperReducer = (state, action) => {
  if(action.type === 'SET') {
    const instance = action.instance;
    return{
      instance  
    }
  }
  return defaultSwiperState;
}


const GoalProvider = (props) => {
  const [goalState, setActiveGoal] = useReducer(
      goalReducer,
      null,
      defaultGoalState
  );

  const [locationState, setActiveLocation] = useReducer(
    locationReducer,
    null,
    defaultLocationState
  );

  const [mapInstanceState, setMapInstance] = useReducer(
    mapInstanceReducer,
    defaultLocationState
  );

  const [markerState, setActiveMarker] = useReducer(
    markerReducer,
    defaultActiveMarkerState
  );

  const [swiperState, setActiveSwiper] = useReducer(
    swiperReducer,
    defaultSwiperState
  );

  const setActiveGoalHandler = (id) => {
    setActiveGoal({type: "SET", id: id})
  };

  const setActiveLocationHandler = (payload) => {
    setActiveLocation({type: "SET", id: payload})
  };

  const setActiveMapInstanceHandler = (payload) => {
    setMapInstance({type: "SET", instance: payload.instance})
  }

  const setActiveMarkerHandler = (id) => {
    setActiveMarker({type: "SET", id: id})
  }

  const setActiveSwiperHandler = (payload) => {
    setActiveSwiper({ type: "SET", instance: payload.instance })
  }

  const goalContext = {
    goals: window.goalData,
    settings: window.dccSettings,
    activeGoal: goalState.activeGoal,
    activeLocation: locationState.activeLocation,
    activeMarker: markerState.activeMarker,
    activeMapInstance: mapInstanceState,
    activeSwiper: swiperState,
    setActiveMarker: setActiveMarkerHandler,
    setActiveGoal: setActiveGoalHandler,
    setActiveLocation: setActiveLocationHandler,
    setMapInstance: setActiveMapInstanceHandler,
    setActiveSwiper: setActiveSwiperHandler
  };

  return (
    <GoalContext.Provider value={goalContext}>
      {props.children}
    </GoalContext.Provider>
  );
};

export default GoalProvider;
